<section class="help-videos-section">
  <div class="help-videos-content">
    <div class="help-videos-header">
      <h2 class="help-videos-title">{{ title() | translateLang }}</h2>
      <p class="help-videos-description">{{ description() | translateLang }}</p>
    </div>

    <div class="help-videos-slider">
      <div class="help-videos-carousel">
        @if (showNavigation()) {
          <button
            type="button"
            class="carousel-arrow"
            (click)="scrollPrev()"
            [attr.aria-label]="'contact.videos.previous' | translateLang"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.4"
              aria-hidden="true"
            >
              <path d="M15 6l-6 6 6 6" />
            </svg>
          </button>
        }

        <div class="help-videos-track" #track (scroll)="onTrackScroll()">
          @for (item of resolvedVideos(); track $index; let i = $index) {
            <div class="video-card">
              <button
                type="button"
                class="video-thumb"
                [attr.aria-label]="item.video.titleKey | translateLang"
                (click)="onVideoClick(item.video, i)"
              >
                @if (thumbnailFor(item); as thumbnailUrl) {
                  <img class="video-thumb-media" [src]="thumbnailUrl" alt="" loading="lazy" />
                } @else if (item.fileUrl) {
                  <!-- First frame of the file as its thumbnail; muted + metadata-only, never plays -->
                  <video
                    class="video-thumb-media"
                    [src]="posterFrameUrl(item.fileUrl)"
                    preload="metadata"
                    muted
                    playsinline
                    tabindex="-1"
                    aria-hidden="true"
                  ></video>
                }
                <span class="play-btn">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </span>
              </button>
              <span class="video-info">
                <!-- Mouse shortcut to the same player; keyboard users reach it via the thumbnail -->
                <button
                  type="button"
                  class="video-info-title"
                  tabindex="-1"
                  (click)="onVideoClick(item.video, i)"
                >
                  {{ item.video.titleKey | translateLang }}
                </button>
                <span class="video-info-description">{{
                  item.video.descriptionKey | translateLang
                }}</span>
              </span>
            </div>
          }
        </div>

        @if (showNavigation()) {
          <button
            type="button"
            class="carousel-arrow"
            (click)="scrollNext()"
            [attr.aria-label]="'contact.videos.next' | translateLang"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.4"
              aria-hidden="true"
            >
              <path d="M9 6l6 6-6 6" />
            </svg>
          </button>
        }
      </div>

      @if (showNavigation()) {
        <!-- Position indicator: one dot per arrow step -->
        <div class="carousel-dots" aria-hidden="true">
          @for (dot of dots(); track dot) {
            <span class="carousel-dot" [class.carousel-dot--active]="dot === activeDot()"></span>
          }
        </div>
      }
    </div>
  </div>
</section>
